import React from 'react';
import TriggerWindowFields from './TriggerWindowFields';
import EligibilityConditionsShared from './EligibilityConditionsShared';

const EligibilityConditionsLifecycle = ({
  formData,
  updateField,
  showValidation = false,
  triggerWindowValidation = false,
  triggerWindowError = false,
}) => {
  return (
    <div className='eligibility-conditions-view'>
      <TriggerWindowFields
        formData={formData}
        updateField={updateField}
        showValidation={triggerWindowValidation}
        errorTriggerWindowDays={triggerWindowError}
      />
      <EligibilityConditionsShared formData={formData} updateField={updateField} showValidation={showValidation} />
    </div>
  );
};

export default EligibilityConditionsLifecycle;
